import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "language-options select" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]


export default /*#__PURE__*/_defineComponent({
  emits: ["select"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "item clean",
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', 'es')))
    }, [
      _createElementVNode("img", {
        src: require(`@flavor/pages/espanol.jpg`),
        alt: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('language.spanish')), 1)
    ]),
    _createElementVNode("button", {
      class: "item clean",
      type: "button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', 'en')))
    }, [
      _createElementVNode("img", {
        src: require(`@flavor/pages/english.jpg`),
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('language.english')), 1)
    ])
  ]))
}
}

})